import clsx from 'clsx'
import { GetStaticProps, GetStaticPropsContext } from 'next'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Layout } from '../container/Layout'
import styles from '../styles/policy.module.scss'

interface Props {
	locale: string
}

export default function Policy({ locale }: Props): JSX.Element {
	const meta = {
		title: [{ text: 'Privacy Policy  – FUCHSFOX', type: '' }],
		description: [{ text: 'Policy', type: '' }],
		keyword: ['Contact', 'Get in touch', 'fuchs', 'fox', 'phone', 'FUCHSFOX', 'fuchsfox', 'Privacy Policy'],
		robot: 'no-index',
	}
	const { t } = useTranslation(['policy', 'contact'])
	return (
		<Layout>
			<div className="inner">
				<section className={clsx(styles.section, styles.left)}>
					<div className={clsx(styles.header)}>
						<h1 className={styles.title}>{t('policy:title')}</h1>
						<h3>{t('policy:information')}</h3>
					</div>
				</section>
				<section className={styles.section}>
					<div className={styles.context}>
						<p>{t('policy:paragraph')}</p>
						<p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
						<h4>{t('policy:responsible')}</h4>
						<p>
							FUCHSFOX GbR
							<br />
							Bismarckstraße 88
							<br />
							20253 Hamburg
							<br />
							{t('contact:country')}
							<br />
							{t('contact:email')}: &nbsp;<a href="mailto:hello@fuchsfox.com">hello@fuchsfox.com</a>
							<br />
							{t('contact:mobile')}: &nbsp;<a href="tel:+4915209001910">+49 152 0900 1910</a>
						</p>
						<h4>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h4>
						<p>
							Nur mit Ihrer ausdrücklichen Einwilligung sind einige Vorgänge der Datenverarbeitung möglich. Ein Widerruf
							Ihrer bereits erteilten Einwilligung ist jederzeit möglich. Für den Widerruf genügt eine formlose
							Mitteilung per E-Mail. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom
							Widerruf unberührt.
						</p>
						<h4>Recht auf Beschwerde bei der zuständigen Aufsichtsbehörde</h4>
						<p>
							Als Betroffener steht Ihnen im Falle eines datenschutzrechtlichen Verstoßes ein Beschwerderecht bei der
							zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde bezüglich datenschutzrechtlicher Fragen ist
							der Landesdatenschutzbeauftragte des Bundeslandes, in dem sich der Sitz unseres Unternehmens befindet. Der
							folgende Link stellt eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten bereit:
							<a href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html">
								https://www.bfdi.bund.de/
							</a>
							.
						</p>
						<h4>Recht auf Datenübertragbarkeit</h4>
						<p>
							Ihnen steht das Recht zu, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags
							automatisiert verarbeiten, an sich oder an Dritte aushändigen zu lassen. Die Bereitstellung erfolgt in
							einem maschinenlesbaren Format. Sofern Sie die direkte Übertragung der Daten an einen anderen
							Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.
						</p>
						<h4>Recht auf Auskunft, Berichtigung, Sperrung, Löschung</h4>
						<p>
							Sie haben jederzeit im Rahmen der geltenden gesetzlichen Bestimmungen das Recht auf unentgeltliche
							Auskunft über Ihre gespeicherten personenbezogenen Daten, Herkunft der Daten, deren Empfänger und den
							Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten.
							Diesbezüglich und auch zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit über
							die im Impressum aufgeführten Kontaktmöglichkeiten an uns wenden.
						</p>
						<h4>Agenturdienstleistungen</h4>
						<p>
							Wir verarbeiten die Daten unserer Kunden im Rahmen unserer vertraglichen Leistungen zu denen
							konzeptionelle und strategische Beratung, Kampagnenplanung, Software- und Designentwicklung/-beratung oder
							Pflege, Umsetzung von Kampagnen und Prozessen/ Handling, Serveradministration, Datenanalyse/
							Beratungsleistungen und Schulungsleistungen gehören.
							<br />
							Hierbei verarbeiten wir Bestandsdaten (z.B., Kundenstammdaten, wie Namen oder Adressen), Kontaktdaten
							(z.B., E-Mail, Telefonnummern), Inhaltsdaten (z.B., Texteingaben, Fotografien, Videos), Vertragsdaten
							(z.B., Vertragsgegenstand, Laufzeit), Zahlungsdaten (z.B., Bankverbindung, Zahlungshistorie), Nutzungs-
							und Metadaten (z.B. im Rahmen der Auswertung und Erfolgsmessung von Marketingmaßnahmen). Besondere
							Kategorien personenbezogener Daten verarbeiten wir grundsätzlich nicht, außer wenn diese Bestandteile
							einer beauftragten Verarbeitung sind. Zu den Betroffenen gehören unsere Kunden, Interessenten sowie deren
							Kunden, Nutzer, Websitebesucher oder Mitarbeiter sowie Dritte. Der Zweck der Verarbeitung besteht in der
							Erbringung von Vertragsleistungen, Abrechnung und unserem Kundenservice. Die Rechtsgrundlagen der
							Verarbeitung ergeben sich aus Art. 6 Abs. 1 lit. b DSGVO (vertragliche Leistungen), Art. 6 Abs. 1 lit. f
							DSGVO (Analyse, Statistik, Optimierung, Sicherheitsmaßnahmen). Wir verarbeiten Daten, die zur Begründung
							und Erfüllung der vertraglichen Leistungen erforderlich sind und weisen auf die Erforderlichkeit ihrer
							Angabe hin. Eine Offenlegung an Externe erfolgt nur, wenn sie im Rahmen eines Auftrags erforderlich ist.
							Bei der Verarbeitung der uns im Rahmen eines Auftrags überlassenen Daten handeln wir entsprechend den
							Weisungen der Auftraggeber sowie der gesetzlichen Vorgaben einer Auftragsverarbeitung gem. Art. 28 DSGVO
							und verarbeiten die Daten zu keinen anderen, als den auftragsgemäßen Zwecken.
							<br />
							Wir löschen die Daten nach Ablauf gesetzlicher Gewährleistungs- und vergleichbarer Pflichten. die
							Erforderlichkeit der Aufbewahrung der Daten wird alle drei Jahre überprüft; im Fall der gesetzlichen
							Archivierungspflichten erfolgt die Löschung nach deren Ablauf (6 J, gem. § 257 Abs. 1 HGB, 10 J, gem. §
							147 Abs. 1 AO). Im Fall von Daten, die uns gegenüber im Rahmen eines Auftrags durch den Auftraggeber
							offengelegt wurden, löschen wir die Daten entsprechend den Vorgaben des Auftrags, grundsätzlich nach Ende
							des Auftrags.
						</p>
						<h4>Hosting und E-Mail-Versand</h4>
						<p>
							Die von uns in Anspruch genommenen Hosting-Leistungen dienen der Zurverfügungstellung der folgenden
							Leistungen: Infrastruktur- und Plattformdienstleistungen, Rechenkapazität, Speicherplatz und
							Datenbankdienste, E-Mail-Versand, Sicherheitsleistungen sowie technische Wartungsleistungen, die wir zum
							Zwecke des Betriebs dieses Onlineangebotes einsetzen.
							<br />
							Hierbei verarbeiten wir, bzw. unser Hostinganbieter Bestandsdaten, Kontaktdaten, Inhaltsdaten,
							Vertragsdaten, Nutzungsdaten, Meta- und Kommunikationsdaten von Kunden, Interessenten und Besuchern dieses
							Onlineangebotes auf Grundlage unserer berechtigten Interessen an einer effizienten und sicheren
							Zurverfügungstellung dieses Onlineangebotes gem. Art. 6 Abs. 1 lit. f DSGVO i.V.m. Art. 28 DSGVO
							(Abschluss Auftragsverarbeitungsvertrag).
						</p>
						<h4>SSL- bzw. TLS-Verschlüsselung</h4>
						<p>
							Aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, die Sie an uns als
							Seitenbetreiber senden, nutzt unsere Website eine SSL-bzw. TLS-Verschlüsselung. Damit sind Daten, die Sie
							über diese Website übermitteln, für Dritte nicht mitlesbar. Sie erkennen eine verschlüsselte Verbindung an
							der „https://“ Adresszeile Ihres Browsers und am Schloss-Symbol in der Browserzeile.
						</p>
						<h4>Server-Log-Dateien</h4>
						<p>
							In Server-Log-Dateien erhebt und speichert der Provider der Website automatisch Informationen, die Ihr
							Browser automatisch an uns übermittelt. Dies sind:
						</p>
						<ul>
							<li>
								<p>Browsertyp und Browserversion</p>
							</li>
							<li>Verwendetes Betriebssystem</li>
							<li>Referrer URL</li>
							<li>Hostname des zugreifenden Rechners</li>
							<li>Uhrzeit der Serveranfrage</li>
							<li>IP-Adresse</li>
						</ul>
						<p>
							Es findet keine Zusammenführung dieser Daten mit anderen Datenquellen statt. Grundlage der
							Datenverarbeitung bildet Art. 6 Abs. 1 lit. b DSGVO, der die Verarbeitung von Daten zur Erfüllung eines
							Vertrags oder vorvertraglicher Maßnahmen gestattet.
						</p>
						<h4>Google Analytics</h4>
						<p>
							Unsere Website verwendet Funktionen des Webanalysedienstes Google Analytics. Anbieter des
							Webanalysedienstes ist die Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.
						</p>
						<p>
							Google Analytics verwendet “Cookies.” Das sind kleine Textdateien, die Ihr Webbrowser auf Ihrem Endgerät
							speichert und eine Analyse der Website-Benutzung ermöglichen. Mittels Cookie erzeugte Informationen über
							Ihre Benutzung unserer Website werden an einen Server von Google übermittelt und dort gespeichert.
							Server-Standort ist im Regelfall die USA.
						</p>
						<p>
							Das Setzen von Google-Analytics-Cookies erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Als
							Betreiber dieser Website haben wir ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um
							unser Webangebot und ggf. auch Werbung zu optimieren.
						</p>
						<h4>IP-Anonymisierung</h4>
						<p>
							Wir setzen Google Analytics in Verbindung mit der Funktion IP-Anonymisierung ein. Sie gewährleistet, dass
							Google Ihre IP-Adresse innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen
							Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum vor der Übermittlung in die USA kürzt.
							Es kann Ausnahmefälle geben, in denen Google die volle IP-Adresse an einen Server in den USA überträgt und
							dort kürzt. In unserem Auftrag wird Google diese Informationen benutzen, um Ihre Nutzung der Website
							auszuwerten, um Reports über Websiteaktivitäten zu erstellen und um weitere mit der Websitenutzung und der
							Internetnutzung verbundene Dienstleistungen gegenüber uns zu erbringen. Es findet keine Zusammenführung
							der von Google Analytics übermittelten IP-Adresse mit anderen Daten von Google statt.
						</p>
						<h4>Browser Plugin</h4>
						<p>
							Das Setzen von Cookies durch Ihren Webbrowser ist verhinderbar. Einige Funktionen unserer Website könnten
							dadurch jedoch eingeschränkt werden. Ebenso können Sie die Erfassung von Daten bezüglich Ihrer
							Website-Nutzung einschließlich Ihrer IP-Adresse mitsamt anschließender Verarbeitung durch Google
							unterbinden. Dies ist möglich, indem Sie das über folgenden Link erreichbare Browser-Plugin herunterladen
							und installieren:{' '}
							<a href="https://tools.google.com/dlpage/gaoptout?hl=de">
								https://tools.google.com/dlpage/gaoptout?hl­de
							</a>
							.
						</p>
						<h4>Widerspruch gegen die Datenerfassung</h4>
						<p>
							Sie können die Erfassung Ihrer Daten durch Google Analytics verhindern, indem Sie auf folgenden Link
							klicken. Es wird ein Opt-Out-Cookie gesetzt, der die Erfassung Ihrer Daten bei zukünftigen Besuchen
							unserer Website verhindert: <a href="gaOptout()">Google Analytics deaktivieren</a>.
						</p>
						<p>
							Einzelheiten zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der Datenschutzerklärung von
							Google:{' '}
							<a href="https://support.google.com/analytics/answer/6004245?hl=de">https://support.google.com/</a>.
						</p>
						<h4>Auftragsverarbeitung</h4>
						<p>
							Zur vollständigen Erfüllung der gesetzlichen Datenschutzvorgaben haben wir mit Google einen Vertrag über
							die Auftragsverarbeitung abgeschlossen.
						</p>
						<h4>Demografische Merkmale bei Google Analytics</h4>
						<p>
							Unsere Website verwendet die Funktion “demografische Merkmale” von Google Analytics. Mit ihr lassen sich
							Berichte erstellen, die Aussagen zu Alter, Geschlecht und Interessen der Seitenbesucher enthalten. Diese
							Daten stammen aus interessenbezogener Werbung von Google sowie aus Besucherdaten von Drittanbietern. Eine
							Zuordnung der Daten zu einer bestimmten Person ist nicht möglich. Sie können diese Funktion jederzeit
							deaktivieren. Dies ist über die Anzeigeneinstellungen in Ihrem Google-Konto möglich oder indem Sie die
							Erfassung Ihrer Daten durch Google Analytics, wie im Punkt “Widerspruch gegen die Datenerfassung”
							erläutert, generell untersagen.
						</p>
						<h4>Google AdWords und Google Conversion-Tracking</h4>
						<p>
							Unsere Website verwendet Google AdWords. Anbieter ist die Google Inc., 1600 Amphitheatre Parkway, Mountain
							View, CA 94043, United States.
						</p>
						<p>
							AdWords ist ein Online-Werbeprogramm. Im Rahmen des Online-Werbeprogramms arbeiten wir mit
							Conversion-Tracking. Nach einem Klick auf eine von Google geschaltete Anzeige wird ein Cookie für das
							Conversion-Tracking gesetzt. Cookies sind kleine Textdateien, die Ihr Webbrowser auf Ihrem Endgerät
							speichert. Google AdWords Cookies verlieren nach 30 Tagen ihre Gültigkeit und dienen nicht der
							persönlichen Identifizierung der Nutzer. Am Cookie können Google und wir erkennen, dass Sie auf eine
							Anzeige geklickt haben und zu unserer Website weitergeleitet wurden.
						</p>
						<p>
							Jeder Google AdWords-Kunde erhält ein anderes Cookie. Die Cookies sind nicht über Websites von
							AdWords-Kunden nachverfolgbar. Mit Conversion-Cookies werden Conversion-Statistiken für AdWords-Kunden,
							die Conversion-Tracking einsetzen, erstellt. Adwords-Kunden erfahren wie viele Nutzer auf ihre Anzeige
							geklickt haben und auf Seiten mit Conversion-Tracking-Tag weitergeleitet wurden. AdWords-Kunden erhalten
							jedoch keine Informationen, die eine persönliche Identifikation der Nutzer ermöglichen. Wenn Sie nicht am
							Tracking teilnehmen möchten, können Sie einer Nutzung widersprechen. Hier ist das Conversion-Cookie in den
							Nutzereinstellungen des Browsers zu deaktivieren. So findet auch keine Aufnahme in die Conversion-Tracking
							Statistiken statt.
						</p>
						<p>
							Die Speicherung von “Conversion-Cookies” erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir als
							Websitebetreiber haben ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um unser Webangebot
							und unsere Werbung zu optimieren.
						</p>
						<p>
							Einzelheiten zu Google AdWords und Google Conversion-Tracking finden Sie in den Datenschutzbestimmungen
							von Google: <a href="https://www.google.de/policies/privacy/">https://www.google.de/policies/privacy/</a>.
						</p>
						<p>
							Mit einem modernen Webbrowser können Sie das Setzen von Cookies überwachen, einschränken oder unterbinden.
							Die Deaktivierung von Cookies kann eine eingeschränkte Funktionalität unserer Website zur Folge haben.
						</p>
						<h4>Kontaktaufnahme</h4>
						<p>
							Bei der Kontaktaufnahme mit uns (z.B. per Kontaktformular, E-Mail, Telefon oder via sozialer Medien)
							werden die Angaben des Nutzers zur Bearbeitung der Kontaktanfrage und deren Abwicklung gem. Art. 6 Abs. 1
							lit. b. (im Rahmen vertraglicher-/vorvertraglicher Beziehungen), Art. 6 Abs. 1 lit. f. (andere Anfragen)
							DSGVO verarbeitet. Die Angaben der Nutzer können in einem Customer-Relationship-Management System
							(&quot;CRM System&quot;) oder vergleichbarer Anfragenorganisation gespeichert werden. Wir löschen die
							Anfragen, sofern diese nicht mehr erforderlich sind. Wir überprüfen die Erforderlichkeit alle zwei Jahre;
							Ferner gelten die gesetzlichen Archivierungspflichten.
						</p>
						<h4>Bewerbungen</h4>
						<p>
							<p>
								Wir verarbeiten Ihre uns übersendeten Bewerbungsunterlagen inkl. der Dateien, die Sie uns zur Verfügung
								stellen, ausschließlich zur Durchführung eines Bewerbungsverfahrens (Art. 6 (1) lit. b DS-GVO). Wir
								kontaktieren Sie im Bewerbungsverfahren, um Sie über den Fortgang Ihrer Bewerbung zu unterrichten bzw.
								Sie zu einem Vorstellungsgespräch einzuladen. Nach Abschluss des Bewerbungsverfahrens werden Ihre Daten
								spätestens nach sechs Monaten gelöscht, sofern Sie nicht eingewilligt haben, dass wir Ihre Daten
								behalten und Sie künftig über passende Stellenangebote informieren dürfen. (Art.&nbsp;6 (1) lit. a
								DS-GVO).
							</p>
						</p>
						<p>This document was last updated on July 11th 2020.</p>
					</div>
				</section>
			</div>
		</Layout>
	)
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext) => {
	return {
		props: {
			locale,
		},
	}
}
